import React from 'react';
import DerivationRulesList from './DerivationRulesList';
/**
 * Route wrapper for the vocabulary derivation rule administration screen
 * (CZNA-365). The list owns selection/create state via the URL query string,
 * so this wrapper is a thin pass-through (no nested :id routes needed).
 * Mirrors `ValidationRules.tsx`.
 */
var DerivationRules = function () { return React.createElement(DerivationRulesList, null); };
export default DerivationRules;
